"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Svg_1 = __importDefault(require("../Svg"));

var CreditCardVisa = function CreditCardVisa(_a) {
  var fill = _a.fill,
      props = __rest(_a, ["fill"]);

  return react_1.default.createElement(Svg_1.default, __assign({}, props, {
    viewBox: "0 0 32 9.812"
  }), react_1.default.createElement("g", {
    transform: "translate(-2.571 -6.606)"
  }, react_1.default.createElement("path", {
    fill: "#005098",
    d: "M11.026,16.235l1.62-9.505h2.591l-1.621,9.505Z",
    transform: "translate(2.818 0.041)"
  }), react_1.default.createElement("path", {
    fill: "#005098",
    d: "M21.959,7.006a6.668,6.668,0,0,0-2.321-.4c-2.56,0-4.364,1.289-4.379,3.137-.015,1.365,1.287,2.128,2.269,2.583,1.008.465,1.348.763,1.343,1.179-.007.637-.805.928-1.549.928a5.432,5.432,0,0,1-2.439-.5l-.335-.151-.363,2.128a8.2,8.2,0,0,0,2.885.507c2.724,0,4.492-1.275,4.512-3.248.009-1.081-.681-1.9-2.176-2.581-.905-.44-1.46-.733-1.455-1.179,0-.4.471-.817,1.484-.817a4.768,4.768,0,0,1,1.94.364l.232.109.351-2.06",
    transform: "translate(3.872 0)"
  }), react_1.default.createElement("path", {
    fill: "#005098",
    d: "M26.8,6.737h-2a1.288,1.288,0,0,0-1.356.788l-3.848,8.711h2.72s.445-1.171.547-1.428l3.317,0c.077.333.315,1.424.315,1.424h2.4l-2.1-9.5m-3.195,6.127c.213-.548,1.032-2.657,1.032-2.657-.016.025.212-.549.343-.907l.176.82.6,2.744Z",
    transform: "translate(5.674 0.044)"
  }), react_1.default.createElement("path", {
    fill: "#005098",
    d: "M11,6.736,8.459,13.217,8.189,11.9A7.417,7.417,0,0,0,4.6,7.913l2.32,8.312,2.741,0L13.74,6.736H11",
    transform: "translate(0.676 0.043)"
  }), react_1.default.createElement("path", {
    fill: "#f6a500",
    d: "M6.782,6.731H2.6l-.033.2A8.581,8.581,0,0,1,8.866,11.9L7.956,7.534a1.084,1.084,0,0,0-1.175-.8",
    transform: "translate(0 0.042)"
  })));
};

CreditCardVisa.displayName = 'CreditCardVisa';
exports.default = CreditCardVisa;